import { inject, injectable } from 'inversify'
import type { SelectOption, SelectSearchWithCustomSubfieldNames } from '@/services/forms/types'
import { SERVICE_TYPES } from '@/core/container/types'
import type TranslateService from '@/services/translateService'
import { ticketsRouteNames } from '@/routes/user/tickets/types'
import { UserSettingsRoutes } from '@/routes/user/settings'
import type TicketInboxService from '@/services/domain/tickets/inboxes/ticketInboxService'
import type FieldSelectSearchWithCustomBuilderService from '@/services/forms/fieldBuilders/FieldSelectSearchWithCustomBuilderService'

@injectable()
export default class SelectInboxFieldBuilderService {
  constructor(
    @inject(SERVICE_TYPES.FieldSelectSearchWithCustomBuilderService)
    protected readonly fieldSelectSearchWithCustomBuilderService: FieldSelectSearchWithCustomBuilderService,
    @inject(SERVICE_TYPES.TranslateService) protected readonly translateService: TranslateService,
    @inject(SERVICE_TYPES.TicketInboxService) protected readonly ticketInboxService: TicketInboxService,
  ) {}

  public getSubfieldValidationRuleName(subFieldName: SelectSearchWithCustomSubfieldNames) {
    return this.fieldSelectSearchWithCustomBuilderService.getSubfieldValidationRuleName(subFieldName)
  }

  public getFieldConfig() {
    return this.fieldSelectSearchWithCustomBuilderService.getFieldConfig('selectSearchInbox')
  }

  public extendOptions(options: SelectOption[]) {
    return this.fieldSelectSearchWithCustomBuilderService.extendOptions({
      options,
      header: this.translateService.t('fieldSelectSearchInbox.connected'),
      addNewText: this.translateService.t('fieldSelectSearchInbox.connectNew'),
      addNewRoute: {
        name: this.ticketInboxService.hasInboxes()
          ? UserSettingsRoutes.TicketsInboxesConnect
          : ticketsRouteNames.gettingStarted,
      },
    })
  }
}
